export default __webpack_public_path__ + "static/media/section1-img1.fbf34762.png";